// IANA zones from Intl.supportedValuesOf('timeZone') (Node 24), plus existing picker aliases.
// Keep this list static so browsers and backend validation offer the same choices.
export var TimeZone;
(function (TimeZone) {
    TimeZone["UTC"] = "UTC";
    TimeZone["Africa/Abidjan"] = "Africa/Abidjan";
    TimeZone["Africa/Accra"] = "Africa/Accra";
    TimeZone["Africa/Addis_Ababa"] = "Africa/Addis_Ababa";
    TimeZone["Africa/Algiers"] = "Africa/Algiers";
    TimeZone["Africa/Asmera"] = "Africa/Asmera";
    TimeZone["Africa/Bamako"] = "Africa/Bamako";
    TimeZone["Africa/Bangui"] = "Africa/Bangui";
    TimeZone["Africa/Banjul"] = "Africa/Banjul";
    TimeZone["Africa/Bissau"] = "Africa/Bissau";
    TimeZone["Africa/Blantyre"] = "Africa/Blantyre";
    TimeZone["Africa/Brazzaville"] = "Africa/Brazzaville";
    TimeZone["Africa/Bujumbura"] = "Africa/Bujumbura";
    TimeZone["Africa/Cairo"] = "Africa/Cairo";
    TimeZone["Africa/Casablanca"] = "Africa/Casablanca";
    TimeZone["Africa/Ceuta"] = "Africa/Ceuta";
    TimeZone["Africa/Conakry"] = "Africa/Conakry";
    TimeZone["Africa/Dakar"] = "Africa/Dakar";
    TimeZone["Africa/Dar_es_Salaam"] = "Africa/Dar_es_Salaam";
    TimeZone["Africa/Djibouti"] = "Africa/Djibouti";
    TimeZone["Africa/Douala"] = "Africa/Douala";
    TimeZone["Africa/El_Aaiun"] = "Africa/El_Aaiun";
    TimeZone["Africa/Freetown"] = "Africa/Freetown";
    TimeZone["Africa/Gaborone"] = "Africa/Gaborone";
    TimeZone["Africa/Harare"] = "Africa/Harare";
    TimeZone["Africa/Johannesburg"] = "Africa/Johannesburg";
    TimeZone["Africa/Juba"] = "Africa/Juba";
    TimeZone["Africa/Kampala"] = "Africa/Kampala";
    TimeZone["Africa/Khartoum"] = "Africa/Khartoum";
    TimeZone["Africa/Kigali"] = "Africa/Kigali";
    TimeZone["Africa/Kinshasa"] = "Africa/Kinshasa";
    TimeZone["Africa/Lagos"] = "Africa/Lagos";
    TimeZone["Africa/Libreville"] = "Africa/Libreville";
    TimeZone["Africa/Lome"] = "Africa/Lome";
    TimeZone["Africa/Luanda"] = "Africa/Luanda";
    TimeZone["Africa/Lubumbashi"] = "Africa/Lubumbashi";
    TimeZone["Africa/Lusaka"] = "Africa/Lusaka";
    TimeZone["Africa/Malabo"] = "Africa/Malabo";
    TimeZone["Africa/Maputo"] = "Africa/Maputo";
    TimeZone["Africa/Maseru"] = "Africa/Maseru";
    TimeZone["Africa/Mbabane"] = "Africa/Mbabane";
    TimeZone["Africa/Mogadishu"] = "Africa/Mogadishu";
    TimeZone["Africa/Monrovia"] = "Africa/Monrovia";
    TimeZone["Africa/Nairobi"] = "Africa/Nairobi";
    TimeZone["Africa/Ndjamena"] = "Africa/Ndjamena";
    TimeZone["Africa/Niamey"] = "Africa/Niamey";
    TimeZone["Africa/Nouakchott"] = "Africa/Nouakchott";
    TimeZone["Africa/Ouagadougou"] = "Africa/Ouagadougou";
    TimeZone["Africa/Porto-Novo"] = "Africa/Porto-Novo";
    TimeZone["Africa/Sao_Tome"] = "Africa/Sao_Tome";
    TimeZone["Africa/Tripoli"] = "Africa/Tripoli";
    TimeZone["Africa/Tunis"] = "Africa/Tunis";
    TimeZone["Africa/Windhoek"] = "Africa/Windhoek";
    TimeZone["America/Adak"] = "America/Adak";
    TimeZone["America/Anchorage"] = "America/Anchorage";
    TimeZone["America/Anguilla"] = "America/Anguilla";
    TimeZone["America/Antigua"] = "America/Antigua";
    TimeZone["America/Araguaina"] = "America/Araguaina";
    TimeZone["America/Argentina/La_Rioja"] = "America/Argentina/La_Rioja";
    TimeZone["America/Argentina/Rio_Gallegos"] = "America/Argentina/Rio_Gallegos";
    TimeZone["America/Argentina/Salta"] = "America/Argentina/Salta";
    TimeZone["America/Argentina/San_Juan"] = "America/Argentina/San_Juan";
    TimeZone["America/Argentina/San_Luis"] = "America/Argentina/San_Luis";
    TimeZone["America/Argentina/Tucuman"] = "America/Argentina/Tucuman";
    TimeZone["America/Argentina/Ushuaia"] = "America/Argentina/Ushuaia";
    TimeZone["America/Aruba"] = "America/Aruba";
    TimeZone["America/Asuncion"] = "America/Asuncion";
    TimeZone["America/Bahia"] = "America/Bahia";
    TimeZone["America/Bahia_Banderas"] = "America/Bahia_Banderas";
    TimeZone["America/Barbados"] = "America/Barbados";
    TimeZone["America/Belem"] = "America/Belem";
    TimeZone["America/Belize"] = "America/Belize";
    TimeZone["America/Blanc-Sablon"] = "America/Blanc-Sablon";
    TimeZone["America/Boa_Vista"] = "America/Boa_Vista";
    TimeZone["America/Bogota"] = "America/Bogota";
    TimeZone["America/Boise"] = "America/Boise";
    TimeZone["America/Buenos_Aires"] = "America/Buenos_Aires";
    TimeZone["America/Cambridge_Bay"] = "America/Cambridge_Bay";
    TimeZone["America/Campo_Grande"] = "America/Campo_Grande";
    TimeZone["America/Cancun"] = "America/Cancun";
    TimeZone["America/Caracas"] = "America/Caracas";
    TimeZone["America/Catamarca"] = "America/Catamarca";
    TimeZone["America/Cayenne"] = "America/Cayenne";
    TimeZone["America/Cayman"] = "America/Cayman";
    TimeZone["America/Chicago"] = "America/Chicago";
    TimeZone["America/Chihuahua"] = "America/Chihuahua";
    TimeZone["America/Ciudad_Juarez"] = "America/Ciudad_Juarez";
    TimeZone["America/Coral_Harbour"] = "America/Coral_Harbour";
    TimeZone["America/Cordoba"] = "America/Cordoba";
    TimeZone["America/Costa_Rica"] = "America/Costa_Rica";
    TimeZone["America/Coyhaique"] = "America/Coyhaique";
    TimeZone["America/Creston"] = "America/Creston";
    TimeZone["America/Cuiaba"] = "America/Cuiaba";
    TimeZone["America/Curacao"] = "America/Curacao";
    TimeZone["America/Danmarkshavn"] = "America/Danmarkshavn";
    TimeZone["America/Dawson"] = "America/Dawson";
    TimeZone["America/Dawson_Creek"] = "America/Dawson_Creek";
    TimeZone["America/Denver"] = "America/Denver";
    TimeZone["America/Detroit"] = "America/Detroit";
    TimeZone["America/Dominica"] = "America/Dominica";
    TimeZone["America/Edmonton"] = "America/Edmonton";
    TimeZone["America/Eirunepe"] = "America/Eirunepe";
    TimeZone["America/El_Salvador"] = "America/El_Salvador";
    TimeZone["America/Fort_Nelson"] = "America/Fort_Nelson";
    TimeZone["America/Fortaleza"] = "America/Fortaleza";
    TimeZone["America/Glace_Bay"] = "America/Glace_Bay";
    TimeZone["America/Godthab"] = "America/Godthab";
    TimeZone["America/Goose_Bay"] = "America/Goose_Bay";
    TimeZone["America/Grand_Turk"] = "America/Grand_Turk";
    TimeZone["America/Grenada"] = "America/Grenada";
    TimeZone["America/Guadeloupe"] = "America/Guadeloupe";
    TimeZone["America/Guatemala"] = "America/Guatemala";
    TimeZone["America/Guayaquil"] = "America/Guayaquil";
    TimeZone["America/Guyana"] = "America/Guyana";
    TimeZone["America/Halifax"] = "America/Halifax";
    TimeZone["America/Havana"] = "America/Havana";
    TimeZone["America/Hermosillo"] = "America/Hermosillo";
    TimeZone["America/Indiana/Knox"] = "America/Indiana/Knox";
    TimeZone["America/Indiana/Marengo"] = "America/Indiana/Marengo";
    TimeZone["America/Indiana/Petersburg"] = "America/Indiana/Petersburg";
    TimeZone["America/Indiana/Tell_City"] = "America/Indiana/Tell_City";
    TimeZone["America/Indiana/Vevay"] = "America/Indiana/Vevay";
    TimeZone["America/Indiana/Vincennes"] = "America/Indiana/Vincennes";
    TimeZone["America/Indiana/Winamac"] = "America/Indiana/Winamac";
    TimeZone["America/Indianapolis"] = "America/Indianapolis";
    TimeZone["America/Inuvik"] = "America/Inuvik";
    TimeZone["America/Iqaluit"] = "America/Iqaluit";
    TimeZone["America/Jamaica"] = "America/Jamaica";
    TimeZone["America/Jujuy"] = "America/Jujuy";
    TimeZone["America/Juneau"] = "America/Juneau";
    TimeZone["America/Kentucky/Monticello"] = "America/Kentucky/Monticello";
    TimeZone["America/Kralendijk"] = "America/Kralendijk";
    TimeZone["America/La_Paz"] = "America/La_Paz";
    TimeZone["America/Lima"] = "America/Lima";
    TimeZone["America/Los_Angeles"] = "America/Los_Angeles";
    TimeZone["America/Louisville"] = "America/Louisville";
    TimeZone["America/Lower_Princes"] = "America/Lower_Princes";
    TimeZone["America/Maceio"] = "America/Maceio";
    TimeZone["America/Managua"] = "America/Managua";
    TimeZone["America/Manaus"] = "America/Manaus";
    TimeZone["America/Marigot"] = "America/Marigot";
    TimeZone["America/Martinique"] = "America/Martinique";
    TimeZone["America/Matamoros"] = "America/Matamoros";
    TimeZone["America/Mazatlan"] = "America/Mazatlan";
    TimeZone["America/Mendoza"] = "America/Mendoza";
    TimeZone["America/Menominee"] = "America/Menominee";
    TimeZone["America/Merida"] = "America/Merida";
    TimeZone["America/Metlakatla"] = "America/Metlakatla";
    TimeZone["America/Mexico_City"] = "America/Mexico_City";
    TimeZone["America/Miquelon"] = "America/Miquelon";
    TimeZone["America/Moncton"] = "America/Moncton";
    TimeZone["America/Monterrey"] = "America/Monterrey";
    TimeZone["America/Montevideo"] = "America/Montevideo";
    TimeZone["America/Montserrat"] = "America/Montserrat";
    TimeZone["America/Nassau"] = "America/Nassau";
    TimeZone["America/New_York"] = "America/New_York";
    TimeZone["America/Nome"] = "America/Nome";
    TimeZone["America/Noronha"] = "America/Noronha";
    TimeZone["America/North_Dakota/Beulah"] = "America/North_Dakota/Beulah";
    TimeZone["America/North_Dakota/Center"] = "America/North_Dakota/Center";
    TimeZone["America/North_Dakota/New_Salem"] = "America/North_Dakota/New_Salem";
    TimeZone["America/Ojinaga"] = "America/Ojinaga";
    TimeZone["America/Panama"] = "America/Panama";
    TimeZone["America/Paramaribo"] = "America/Paramaribo";
    TimeZone["America/Phoenix"] = "America/Phoenix";
    TimeZone["America/Port-au-Prince"] = "America/Port-au-Prince";
    TimeZone["America/Port_of_Spain"] = "America/Port_of_Spain";
    TimeZone["America/Porto_Velho"] = "America/Porto_Velho";
    TimeZone["America/Puerto_Rico"] = "America/Puerto_Rico";
    TimeZone["America/Punta_Arenas"] = "America/Punta_Arenas";
    TimeZone["America/Rankin_Inlet"] = "America/Rankin_Inlet";
    TimeZone["America/Recife"] = "America/Recife";
    TimeZone["America/Regina"] = "America/Regina";
    TimeZone["America/Resolute"] = "America/Resolute";
    TimeZone["America/Rio_Branco"] = "America/Rio_Branco";
    TimeZone["America/Santarem"] = "America/Santarem";
    TimeZone["America/Santiago"] = "America/Santiago";
    TimeZone["America/Santo_Domingo"] = "America/Santo_Domingo";
    TimeZone["America/Sao_Paulo"] = "America/Sao_Paulo";
    TimeZone["America/Scoresbysund"] = "America/Scoresbysund";
    TimeZone["America/Sitka"] = "America/Sitka";
    TimeZone["America/St_Barthelemy"] = "America/St_Barthelemy";
    TimeZone["America/St_Johns"] = "America/St_Johns";
    TimeZone["America/St_Kitts"] = "America/St_Kitts";
    TimeZone["America/St_Lucia"] = "America/St_Lucia";
    TimeZone["America/St_Thomas"] = "America/St_Thomas";
    TimeZone["America/St_Vincent"] = "America/St_Vincent";
    TimeZone["America/Swift_Current"] = "America/Swift_Current";
    TimeZone["America/Tegucigalpa"] = "America/Tegucigalpa";
    TimeZone["America/Thule"] = "America/Thule";
    TimeZone["America/Tijuana"] = "America/Tijuana";
    TimeZone["America/Toronto"] = "America/Toronto";
    TimeZone["America/Tortola"] = "America/Tortola";
    TimeZone["America/Vancouver"] = "America/Vancouver";
    TimeZone["America/Whitehorse"] = "America/Whitehorse";
    TimeZone["America/Winnipeg"] = "America/Winnipeg";
    TimeZone["America/Yakutat"] = "America/Yakutat";
    TimeZone["Antarctica/Casey"] = "Antarctica/Casey";
    TimeZone["Antarctica/Davis"] = "Antarctica/Davis";
    TimeZone["Antarctica/DumontDUrville"] = "Antarctica/DumontDUrville";
    TimeZone["Antarctica/Macquarie"] = "Antarctica/Macquarie";
    TimeZone["Antarctica/Mawson"] = "Antarctica/Mawson";
    TimeZone["Antarctica/McMurdo"] = "Antarctica/McMurdo";
    TimeZone["Antarctica/Palmer"] = "Antarctica/Palmer";
    TimeZone["Antarctica/Rothera"] = "Antarctica/Rothera";
    TimeZone["Antarctica/Syowa"] = "Antarctica/Syowa";
    TimeZone["Antarctica/Troll"] = "Antarctica/Troll";
    TimeZone["Antarctica/Vostok"] = "Antarctica/Vostok";
    TimeZone["Arctic/Longyearbyen"] = "Arctic/Longyearbyen";
    TimeZone["Asia/Aden"] = "Asia/Aden";
    TimeZone["Asia/Almaty"] = "Asia/Almaty";
    TimeZone["Asia/Amman"] = "Asia/Amman";
    TimeZone["Asia/Anadyr"] = "Asia/Anadyr";
    TimeZone["Asia/Aqtau"] = "Asia/Aqtau";
    TimeZone["Asia/Aqtobe"] = "Asia/Aqtobe";
    TimeZone["Asia/Ashgabat"] = "Asia/Ashgabat";
    TimeZone["Asia/Atyrau"] = "Asia/Atyrau";
    TimeZone["Asia/Baghdad"] = "Asia/Baghdad";
    TimeZone["Asia/Bahrain"] = "Asia/Bahrain";
    TimeZone["Asia/Baku"] = "Asia/Baku";
    TimeZone["Asia/Bangkok"] = "Asia/Bangkok";
    TimeZone["Asia/Barnaul"] = "Asia/Barnaul";
    TimeZone["Asia/Beirut"] = "Asia/Beirut";
    TimeZone["Asia/Bishkek"] = "Asia/Bishkek";
    TimeZone["Asia/Brunei"] = "Asia/Brunei";
    TimeZone["Asia/Calcutta"] = "Asia/Calcutta";
    TimeZone["Asia/Chita"] = "Asia/Chita";
    TimeZone["Asia/Colombo"] = "Asia/Colombo";
    TimeZone["Asia/Damascus"] = "Asia/Damascus";
    TimeZone["Asia/Dhaka"] = "Asia/Dhaka";
    TimeZone["Asia/Dili"] = "Asia/Dili";
    TimeZone["Asia/Dubai"] = "Asia/Dubai";
    TimeZone["Asia/Dushanbe"] = "Asia/Dushanbe";
    TimeZone["Asia/Famagusta"] = "Asia/Famagusta";
    TimeZone["Asia/Gaza"] = "Asia/Gaza";
    TimeZone["Asia/Hebron"] = "Asia/Hebron";
    TimeZone["Asia/Hong_Kong"] = "Asia/Hong_Kong";
    TimeZone["Asia/Hovd"] = "Asia/Hovd";
    TimeZone["Asia/Irkutsk"] = "Asia/Irkutsk";
    TimeZone["Asia/Jakarta"] = "Asia/Jakarta";
    TimeZone["Asia/Jayapura"] = "Asia/Jayapura";
    TimeZone["Asia/Jerusalem"] = "Asia/Jerusalem";
    TimeZone["Asia/Kabul"] = "Asia/Kabul";
    TimeZone["Asia/Kamchatka"] = "Asia/Kamchatka";
    TimeZone["Asia/Karachi"] = "Asia/Karachi";
    TimeZone["Asia/Kathmandu"] = "Asia/Kathmandu";
    TimeZone["Asia/Katmandu"] = "Asia/Katmandu";
    TimeZone["Asia/Khandyga"] = "Asia/Khandyga";
    TimeZone["Asia/Kolkata"] = "Asia/Kolkata";
    TimeZone["Asia/Krasnoyarsk"] = "Asia/Krasnoyarsk";
    TimeZone["Asia/Kuala_Lumpur"] = "Asia/Kuala_Lumpur";
    TimeZone["Asia/Kuching"] = "Asia/Kuching";
    TimeZone["Asia/Kuwait"] = "Asia/Kuwait";
    TimeZone["Asia/Macau"] = "Asia/Macau";
    TimeZone["Asia/Magadan"] = "Asia/Magadan";
    TimeZone["Asia/Makassar"] = "Asia/Makassar";
    TimeZone["Asia/Manila"] = "Asia/Manila";
    TimeZone["Asia/Muscat"] = "Asia/Muscat";
    TimeZone["Asia/Nicosia"] = "Asia/Nicosia";
    TimeZone["Asia/Novokuznetsk"] = "Asia/Novokuznetsk";
    TimeZone["Asia/Novosibirsk"] = "Asia/Novosibirsk";
    TimeZone["Asia/Omsk"] = "Asia/Omsk";
    TimeZone["Asia/Oral"] = "Asia/Oral";
    TimeZone["Asia/Phnom_Penh"] = "Asia/Phnom_Penh";
    TimeZone["Asia/Pontianak"] = "Asia/Pontianak";
    TimeZone["Asia/Pyongyang"] = "Asia/Pyongyang";
    TimeZone["Asia/Qatar"] = "Asia/Qatar";
    TimeZone["Asia/Qostanay"] = "Asia/Qostanay";
    TimeZone["Asia/Qyzylorda"] = "Asia/Qyzylorda";
    TimeZone["Asia/Rangoon"] = "Asia/Rangoon";
    TimeZone["Asia/Riyadh"] = "Asia/Riyadh";
    TimeZone["Asia/Saigon"] = "Asia/Saigon";
    TimeZone["Asia/Sakhalin"] = "Asia/Sakhalin";
    TimeZone["Asia/Samarkand"] = "Asia/Samarkand";
    TimeZone["Asia/Seoul"] = "Asia/Seoul";
    TimeZone["Asia/Shanghai"] = "Asia/Shanghai";
    TimeZone["Asia/Singapore"] = "Asia/Singapore";
    TimeZone["Asia/Srednekolymsk"] = "Asia/Srednekolymsk";
    TimeZone["Asia/Taipei"] = "Asia/Taipei";
    TimeZone["Asia/Tashkent"] = "Asia/Tashkent";
    TimeZone["Asia/Tbilisi"] = "Asia/Tbilisi";
    TimeZone["Asia/Tehran"] = "Asia/Tehran";
    TimeZone["Asia/Thimphu"] = "Asia/Thimphu";
    TimeZone["Asia/Tokyo"] = "Asia/Tokyo";
    TimeZone["Asia/Tomsk"] = "Asia/Tomsk";
    TimeZone["Asia/Ulaanbaatar"] = "Asia/Ulaanbaatar";
    TimeZone["Asia/Urumqi"] = "Asia/Urumqi";
    TimeZone["Asia/Ust-Nera"] = "Asia/Ust-Nera";
    TimeZone["Asia/Vientiane"] = "Asia/Vientiane";
    TimeZone["Asia/Vladivostok"] = "Asia/Vladivostok";
    TimeZone["Asia/Yakutsk"] = "Asia/Yakutsk";
    TimeZone["Asia/Yekaterinburg"] = "Asia/Yekaterinburg";
    TimeZone["Asia/Yerevan"] = "Asia/Yerevan";
    TimeZone["Atlantic/Azores"] = "Atlantic/Azores";
    TimeZone["Atlantic/Bermuda"] = "Atlantic/Bermuda";
    TimeZone["Atlantic/Canary"] = "Atlantic/Canary";
    TimeZone["Atlantic/Cape_Verde"] = "Atlantic/Cape_Verde";
    TimeZone["Atlantic/Faeroe"] = "Atlantic/Faeroe";
    TimeZone["Atlantic/Madeira"] = "Atlantic/Madeira";
    TimeZone["Atlantic/Reykjavik"] = "Atlantic/Reykjavik";
    TimeZone["Atlantic/South_Georgia"] = "Atlantic/South_Georgia";
    TimeZone["Atlantic/St_Helena"] = "Atlantic/St_Helena";
    TimeZone["Atlantic/Stanley"] = "Atlantic/Stanley";
    TimeZone["Australia/Adelaide"] = "Australia/Adelaide";
    TimeZone["Australia/Brisbane"] = "Australia/Brisbane";
    TimeZone["Australia/Broken_Hill"] = "Australia/Broken_Hill";
    TimeZone["Australia/Darwin"] = "Australia/Darwin";
    TimeZone["Australia/Eucla"] = "Australia/Eucla";
    TimeZone["Australia/Hobart"] = "Australia/Hobart";
    TimeZone["Australia/Lindeman"] = "Australia/Lindeman";
    TimeZone["Australia/Lord_Howe"] = "Australia/Lord_Howe";
    TimeZone["Australia/Melbourne"] = "Australia/Melbourne";
    TimeZone["Australia/Perth"] = "Australia/Perth";
    TimeZone["Australia/Sydney"] = "Australia/Sydney";
    TimeZone["Europe/Amsterdam"] = "Europe/Amsterdam";
    TimeZone["Europe/Andorra"] = "Europe/Andorra";
    TimeZone["Europe/Astrakhan"] = "Europe/Astrakhan";
    TimeZone["Europe/Athens"] = "Europe/Athens";
    TimeZone["Europe/Belgrade"] = "Europe/Belgrade";
    TimeZone["Europe/Berlin"] = "Europe/Berlin";
    TimeZone["Europe/Bratislava"] = "Europe/Bratislava";
    TimeZone["Europe/Brussels"] = "Europe/Brussels";
    TimeZone["Europe/Bucharest"] = "Europe/Bucharest";
    TimeZone["Europe/Budapest"] = "Europe/Budapest";
    TimeZone["Europe/Busingen"] = "Europe/Busingen";
    TimeZone["Europe/Chisinau"] = "Europe/Chisinau";
    TimeZone["Europe/Copenhagen"] = "Europe/Copenhagen";
    TimeZone["Europe/Dublin"] = "Europe/Dublin";
    TimeZone["Europe/Gibraltar"] = "Europe/Gibraltar";
    TimeZone["Europe/Guernsey"] = "Europe/Guernsey";
    TimeZone["Europe/Helsinki"] = "Europe/Helsinki";
    TimeZone["Europe/Isle_of_Man"] = "Europe/Isle_of_Man";
    TimeZone["Europe/Istanbul"] = "Europe/Istanbul";
    TimeZone["Europe/Jersey"] = "Europe/Jersey";
    TimeZone["Europe/Kaliningrad"] = "Europe/Kaliningrad";
    TimeZone["Europe/Kiev"] = "Europe/Kiev";
    TimeZone["Europe/Kirov"] = "Europe/Kirov";
    TimeZone["Europe/Lisbon"] = "Europe/Lisbon";
    TimeZone["Europe/Ljubljana"] = "Europe/Ljubljana";
    TimeZone["Europe/London"] = "Europe/London";
    TimeZone["Europe/Luxembourg"] = "Europe/Luxembourg";
    TimeZone["Europe/Madrid"] = "Europe/Madrid";
    TimeZone["Europe/Malta"] = "Europe/Malta";
    TimeZone["Europe/Mariehamn"] = "Europe/Mariehamn";
    TimeZone["Europe/Minsk"] = "Europe/Minsk";
    TimeZone["Europe/Monaco"] = "Europe/Monaco";
    TimeZone["Europe/Moscow"] = "Europe/Moscow";
    TimeZone["Europe/Oslo"] = "Europe/Oslo";
    TimeZone["Europe/Paris"] = "Europe/Paris";
    TimeZone["Europe/Podgorica"] = "Europe/Podgorica";
    TimeZone["Europe/Prague"] = "Europe/Prague";
    TimeZone["Europe/Riga"] = "Europe/Riga";
    TimeZone["Europe/Rome"] = "Europe/Rome";
    TimeZone["Europe/Samara"] = "Europe/Samara";
    TimeZone["Europe/San_Marino"] = "Europe/San_Marino";
    TimeZone["Europe/Sarajevo"] = "Europe/Sarajevo";
    TimeZone["Europe/Saratov"] = "Europe/Saratov";
    TimeZone["Europe/Simferopol"] = "Europe/Simferopol";
    TimeZone["Europe/Skopje"] = "Europe/Skopje";
    TimeZone["Europe/Sofia"] = "Europe/Sofia";
    TimeZone["Europe/Stockholm"] = "Europe/Stockholm";
    TimeZone["Europe/Tallinn"] = "Europe/Tallinn";
    TimeZone["Europe/Tirane"] = "Europe/Tirane";
    TimeZone["Europe/Ulyanovsk"] = "Europe/Ulyanovsk";
    TimeZone["Europe/Vaduz"] = "Europe/Vaduz";
    TimeZone["Europe/Vatican"] = "Europe/Vatican";
    TimeZone["Europe/Vienna"] = "Europe/Vienna";
    TimeZone["Europe/Vilnius"] = "Europe/Vilnius";
    TimeZone["Europe/Volgograd"] = "Europe/Volgograd";
    TimeZone["Europe/Warsaw"] = "Europe/Warsaw";
    TimeZone["Europe/Zagreb"] = "Europe/Zagreb";
    TimeZone["Europe/Zurich"] = "Europe/Zurich";
    TimeZone["Indian/Antananarivo"] = "Indian/Antananarivo";
    TimeZone["Indian/Chagos"] = "Indian/Chagos";
    TimeZone["Indian/Christmas"] = "Indian/Christmas";
    TimeZone["Indian/Cocos"] = "Indian/Cocos";
    TimeZone["Indian/Comoro"] = "Indian/Comoro";
    TimeZone["Indian/Kerguelen"] = "Indian/Kerguelen";
    TimeZone["Indian/Mahe"] = "Indian/Mahe";
    TimeZone["Indian/Maldives"] = "Indian/Maldives";
    TimeZone["Indian/Mauritius"] = "Indian/Mauritius";
    TimeZone["Indian/Mayotte"] = "Indian/Mayotte";
    TimeZone["Indian/Reunion"] = "Indian/Reunion";
    TimeZone["Pacific/Apia"] = "Pacific/Apia";
    TimeZone["Pacific/Auckland"] = "Pacific/Auckland";
    TimeZone["Pacific/Bougainville"] = "Pacific/Bougainville";
    TimeZone["Pacific/Chatham"] = "Pacific/Chatham";
    TimeZone["Pacific/Easter"] = "Pacific/Easter";
    TimeZone["Pacific/Efate"] = "Pacific/Efate";
    TimeZone["Pacific/Enderbury"] = "Pacific/Enderbury";
    TimeZone["Pacific/Fakaofo"] = "Pacific/Fakaofo";
    TimeZone["Pacific/Fiji"] = "Pacific/Fiji";
    TimeZone["Pacific/Funafuti"] = "Pacific/Funafuti";
    TimeZone["Pacific/Galapagos"] = "Pacific/Galapagos";
    TimeZone["Pacific/Gambier"] = "Pacific/Gambier";
    TimeZone["Pacific/Guadalcanal"] = "Pacific/Guadalcanal";
    TimeZone["Pacific/Guam"] = "Pacific/Guam";
    TimeZone["Pacific/Honolulu"] = "Pacific/Honolulu";
    TimeZone["Pacific/Kiritimati"] = "Pacific/Kiritimati";
    TimeZone["Pacific/Kosrae"] = "Pacific/Kosrae";
    TimeZone["Pacific/Kwajalein"] = "Pacific/Kwajalein";
    TimeZone["Pacific/Majuro"] = "Pacific/Majuro";
    TimeZone["Pacific/Marquesas"] = "Pacific/Marquesas";
    TimeZone["Pacific/Midway"] = "Pacific/Midway";
    TimeZone["Pacific/Nauru"] = "Pacific/Nauru";
    TimeZone["Pacific/Niue"] = "Pacific/Niue";
    TimeZone["Pacific/Norfolk"] = "Pacific/Norfolk";
    TimeZone["Pacific/Noumea"] = "Pacific/Noumea";
    TimeZone["Pacific/Pago_Pago"] = "Pacific/Pago_Pago";
    TimeZone["Pacific/Palau"] = "Pacific/Palau";
    TimeZone["Pacific/Pitcairn"] = "Pacific/Pitcairn";
    TimeZone["Pacific/Ponape"] = "Pacific/Ponape";
    TimeZone["Pacific/Port_Moresby"] = "Pacific/Port_Moresby";
    TimeZone["Pacific/Rarotonga"] = "Pacific/Rarotonga";
    TimeZone["Pacific/Saipan"] = "Pacific/Saipan";
    TimeZone["Pacific/Tahiti"] = "Pacific/Tahiti";
    TimeZone["Pacific/Tarawa"] = "Pacific/Tarawa";
    TimeZone["Pacific/Tongatapu"] = "Pacific/Tongatapu";
    TimeZone["Pacific/Truk"] = "Pacific/Truk";
    TimeZone["Pacific/Wake"] = "Pacific/Wake";
    TimeZone["Pacific/Wallis"] = "Pacific/Wallis";
})(TimeZone || (TimeZone = {}));
export const isTimeZone = (timezone) => Object.values(TimeZone).includes(timezone);
/**
 * Sentinel values for a query's timezone setting. Anything that is not one of
 * these keywords is treated as an override IANA zone.
 */
export const PROJECT_TIMEZONE_SETTING = 'project_timezone';
export const USER_TIMEZONE_SETTING = 'user_timezone';
/**
 * Narrows an untrusted timezone string into a persisted TimezoneSetting. Keeps
 * the keywords and any supported TimeZone; anything else (an unsupported zone)
 * falls back to the project default rather than storing an arbitrary string.
 */
export function toTimezoneSetting(value) {
    if (!value || value === PROJECT_TIMEZONE_SETTING) {
        return PROJECT_TIMEZONE_SETTING;
    }
    if (value === USER_TIMEZONE_SETTING) {
        return USER_TIMEZONE_SETTING;
    }
    return isTimeZone(value) ? value : PROJECT_TIMEZONE_SETTING;
}
//# sourceMappingURL=timezone.js.map